import {
  validateOrganizationNumber,
  validatePersonNo,
  validateSwedishNumber,
} from "us.collection.case/functions";
import * as Yup from "yup";
import {
  organizationNoValidate,
  personNoValidation,
} from "us.collection/functions";
import { SystemCountryCodeFormat } from "us.collection.case/components/OtherParty/Add/Constants";

interface IEmployer extends Yup.MixedSchema {
  otherPartyType: string;
  lastName: string;
  otherpartyRoleType: string;
  country: string;
  zipCode: string;
  emailAddress: string;
  telephoneNo: number;
  systemCountryCode: string;
}

const EmployerSchema = Yup.object<IEmployer>().shape({
  otherPartyType: Yup.string().required(
    "US.COLLECTION.VALIDATIONS:REQUIRED.TYPE_IS_REQUIRED"
  ),
  lastName: Yup.string().required(
    "US.COLLECTION.VALIDATIONS:REQUIRED.LAST_NAME_IS_REQUIRED"
  ),
  systemCountryCode: Yup.string(),
  zipCode: Yup.string()
    .required("US.COLLECTION.VALIDATIONS:REQUIRED.POSTAL_CODE_IS_REQUIRED")
    .when(["country", "systemCountryCode"], {
      is: (countryCode: string, systemCountryCode: string) =>
        countryCode === systemCountryCode,
      then: Yup.string().matches(
        /^\d+$/,
        "US.COLLECTION.VALIDATIONS:REQUIRED.PLEASE_ADD_A_VALID_VALUE_INTO_THE_FIELD"
      ),
    }),
  otherpartyRoleType: Yup.string().required(
    "US.COLLECTION.VALIDATIONS:REQUIRED.ROLE_TYPE_IS_REQUIRED"
  ),
  country: Yup.string().required(
    "US.COLLECTION.VALIDATIONS:REQUIRED.COUNTRY_IS_REQUIRED"
  ),
  nin: Yup.string().when("otherPartyType", {
    is: (val) => val === "N",
    then: Yup.string()
      .typeError(
        "US.COLLECTION.VALIDATIONS:REQUIRED.FIELD_VALUE_IS_IN_INCORRECT_FORMAT"
      )
      .test(
        "organizationNo",
        "US.COLLECTION.VALIDATIONS:REQUIRED.PLEASE_ADD_A_VALID_VALUE_INTO_THE_FIELD",
        function (value) {
          if (!value) return true;
          const systemCountryCode = this.parent.systemCountryCode; 
          if (
            systemCountryCode?.toLowerCase() === SystemCountryCodeFormat.NO
          ) {
            return organizationNoValidate(value);
          } else {
            return true;
          }
        }
      ),
    otherwise: Yup.string()
      .typeError(
        "US.COLLECTION.VALIDATIONS:REQUIRED.FIELD_VALUE_IS_IN_INCORRECT_FORMAT"
      )
      .test(
        "personNo",
        "US.COLLECTION.VALIDATIONS:REQUIRED.PLEASE_ADD_A_VALID_VALUE_INTO_THE_FIELD",
        function (value) {
          if (!value) return true;
          const systemCountryCode = this.parent.systemCountryCode; 
          if (
            systemCountryCode?.toLowerCase() === SystemCountryCodeFormat.NO
          ) {
            const result = validatePersonNo(value.replaceAll(/\D/g, ""));
            const result2 = personNoValidation(value);
            return result.isValid || result2;
          } else {
            return true;
          }
        }
      ),
  }),
  emailAddress: Yup.string().email(
    "US.COLLECTION.VALIDATIONS:REQUIRED.PLEASE_ADD_A_VALID_VALUE_INTO_THE_FIELD"
  ),
  telephoneNo: Yup.string()
    .typeError(
      "US.COLLECTION.VALIDATIONS:REQUIRED.PLEASE_ADD_A_VALID_VALUE_INTO_THE_FIELD"
    )
    .matches(
      /^\d{4,15}$/g,
      "US.COLLECTION.VALIDATIONS:REQUIRED.THE_NUMBER_SHOULD_CONTAIN_BETWEEN_4_AND_15_DIGITS"
    )
    .nullable(),
});

export default EmployerSchema;
